module.exports = __webpack_public_path__ + "static/media/cold.80df5203.svg";